module.exports = __webpack_public_path__ + "static/Marko's Resume-196ff51967d3077310df7b75b429fd25.pdf";